import { Session } from '@ory/client';

import { OryFlowType } from '../constants';

export interface UiNode {
  attributes?: { name?: string; type?: string; value?: any };
  messages?: Array<{ text: string }>;
}

export interface Flow {
  id: string;
  ui?: {
    nodes?: UiNode[];
    action?: string;
    method?: string;
  };
  csrf_token?: string;
  expires_at?: string;
  issued_at?: string;
  request_url?: string;
  return_to?: string;
}

export interface LoginFlow extends Flow {
  forced?: boolean;
  refresh?: boolean;
}

export interface RegistrationFlow extends Flow {
  transient_payload?: Record<string, any>;
}

export interface AuthError {
  message: string;
  code?: number;
  status?: number;
}

export interface OryAuthState {
  // Session state
  session: Session | null;
  sessionLoading: boolean;
  sessionError: AuthError | null;

  // Login flow
  loginFlow: LoginFlow | null;
  loginFlowLoading: boolean;
  loginFlowError: AuthError | null;

  // Registration flow
  registrationFlow: RegistrationFlow | null;
  registrationFlowLoading: boolean;
  registrationFlowError: AuthError | null;

  // Flow state
  flowId: string | null;
  flowType: OryFlowType | string | null;
  csrfToken: string | null;

  // Form Data
  registrationFormData: RegistrationFormData | null;
  loginFormData: LoginFormData | null;

  // Submit state
  isSubmitting: boolean;
  submitError: AuthError | null;

  // Resend state
  isResending: boolean;
  resendError: AuthError | null;

  // Resend countdown (in seconds)
  resendCountdown: number;

  // Logout
  logoutLoading: boolean;
  logoutError: AuthError | null;

  // Redirect parameters for post-registration navigation
  redirectTo: string | null;
}

export const initialOryAuthState: OryAuthState = {
  session: null,
  sessionLoading: false,
  sessionError: null,

  flowId: null,
  flowType: null,
  csrfToken: null,

  registrationFormData: null,
  loginFormData: null,

  loginFlow: null,
  loginFlowLoading: false,
  loginFlowError: null,

  registrationFlow: null,
  registrationFlowLoading: false,
  registrationFlowError: null,

  isSubmitting: false,
  submitError: {
    code: 4000007,
    message:
      'An account with the same identifier (email, phone, username, ...) exists already.',
    status: 400,
  },

  isResending: false,
  resendError: null,
  resendCountdown: 0,

  logoutLoading: false,
  logoutError: null,

  redirectTo: null,
};

export interface csrfProtectedData {
  csrf_token?: string;
}

export interface LoginFormData extends csrfProtectedData {
  email: string;
}

export interface RegistrationFormData extends csrfProtectedData {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
}

export interface OtpFormData extends csrfProtectedData {
  code: string;
}
